import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from '../services/authentication.service';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {
    constructor(private authService: AuthenticationService, private router: Router) {}
    intercept(req: HttpRequest<any> , next: HttpHandler):
    Observable<HttpEvent<any>> {

        if (this.authService.getToken()){
        req = req.clone({
            setHeaders: {
                'Authorization': `Bearer ${this.authService.getToken()}`,
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin' : '*'
            }
        });
        } else {
            req = req.clone({
                setHeaders: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin' : '*'
                }
            });
        }
        return next.handle(req).pipe(catchError((error, caught) => {
            this.handleAuthError(error);
            return of(error);
        }) as any);
    }
    private handleAuthError(err: HttpErrorResponse): Observable<any> {
        // handle your auth error or rethrow
        if (err.status === 401) {
          // navigate /delete cookies or whatever
         localStorage.clear();
          console.log('handled error ' + err.status);
         this.router.navigate([`/login`]);
          return of(err.message);
        }
        throw err;
      }
}
